import { useT } from "../i18n/store";
import { PaperSection } from "./sections/PaperSection";
import { MarginsSection } from "./sections/MarginsSection";
import { SignSizeSection } from "./sections/SignSizeSection";
import { TilingSection } from "./sections/TilingSection";
import { CutGuidesSection } from "./sections/CutGuidesSection";
import { OutputSection } from "./sections/OutputSection";

export const PropertiesPanel = () => {
  const t = useT();
  return (
    <aside className="panel right">
      <div className="panel-header">{t("panel.props")}</div>
      <PaperSection />
      <MarginsSection />
      <SignSizeSection />
      <TilingSection />
      <CutGuidesSection />
      <OutputSection />
    </aside>
  );
};
